var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('LayoutBroker',{attrs:{"layouts":_vm.$options.layouts,"current":_vm.$route.meta.layout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }